import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { CommonKeys } from '@components/EntityDrawers/constants/keys';
import { ISelectOption } from '@constants/entities/ui';
import useCurrentAsset from '@hooks/useCurrentAsset';
import useProjectId from '@hooks/useProjectId';
import { useGetBusinessAttributesQuery } from '@store/services/nodes';

const useBusinessAttributesOptions = (isOpened: boolean) => {
  const projectId = useProjectId(true);
  const currentAsset = useCurrentAsset();
  const { control } = useFormContext();
  const selectedDomains = useWatch({
    control,
    name: CommonKeys.Domains,
  });

  const domainIds =
    selectedDomains?.map(({ value }: ISelectOption) => value) ??
    currentAsset.dto?.domainNodes?.map(({ domain_id }) => domain_id) ??
    [];

  const { data, isLoading, isFetching } = useGetBusinessAttributesQuery(
    {
      projectId,
      domainIds,
    },
    { skip: !isOpened },
  );

  const options: ISelectOption[] = useMemo(() => {
    return (data ?? []).map(({ id, name }) => ({ value: id, label: name }));
  }, [data]);

  return {
    options,
    isLoading: isLoading || isFetching,
  };
};

export default useBusinessAttributesOptions;
